import { render } from "./ChosenTags.vue?vue&type=template&id=b4d98de8&ts=true"
import script from "./ChosenTags.vue?vue&type=script&lang=ts"
export * from "./ChosenTags.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__